<script>
import { onMount } from 'svelte';
import toml from 'toml';
import Link from './Link.svelte';

export let isMobile;

let projects = [];

onMount(async () => {
    const response = await fetch('projects.toml');
    const unparsedToml = await response.text();
    projects = toml.parse(unparsedToml).projects;
});

</script>

<style>
.portfolio {
    margin: 100px auto;
    position: relative;
}

.portfolio:before,
.portfolio:after {
    content: '';
    position: absolute;
    left: 0px;
    width: 100%;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    height: 3px;
}

.portfolio:before {
    top: -2em;
}

.portfolio:after {
    bottom: -2em;
}

.column-one,
.column-two {
    float: left;
}

.column-one {
    width: calc(66% - 1em);
    padding-right: 0.5em;
    margin-right: 0.5em;
    border-right: 1px solid #ccc;    
}

.column-two {
    width: 33%;
}

@media (max-width: 600px) {
    .column-one,
    .column-two {
        width: 100%;
        float: none;
    }
    
    .column-two {
        border-top: 1px solid #e3e3e3;
    }
}

</style>

<div class="portfolio">

    {#if !isMobile}
        <div class="column-one">
            {#each projects.filter(d => d.column === 1) as project (project.key)}
                <Link {...project} />
            {/each}
        </div>
        <div class="column-two">
            {#each projects.filter(d => d.column === 2) as project (project.key)}
                <Link {...project} />
            {/each}
        </div>
        <div class="clear"></div>
    {:else}
        <div class="column-one">
            {#each projects as project (project.key)}
                <Link
                    {...project}
                    isMobile={isMobile}
                />
            {/each}
        </div>
        <div class="clear"></div>
    {/if}
    
</div>